// The props of Save button comes from the parent card
import { CookieToasterTranslation } from '../../../../_helpers/manageCookies';
import { SeriesItemData } from '../cards/series-item-card/SeriesItemCardProps';

export type SaveButtonProps = {
	isSaved: boolean;
	saveConfig: SaveConfig;
	item: SeriesItemData;

	variant?: SaveButtonVariant;
	className?: string;
	buttonState?: SaveButtonState;
	brand?: Brand;

	parentIsHovered: boolean;
	parentIsFocusVisible: boolean;
	onClick?: () => void;
};

// The base, plain props for Save button base component
export type SaveButtonBaseProps = {
	className?: string;
	brand?: Brand;
	buttonState: SaveButtonState;
	item?: SeriesItemData;
	saveDataLinkEvent: string;
	savedDefaultIsVisible: boolean;
	unsavedDefaultIsVisible: boolean;
	tooltipDisabled: boolean;
	saveAriaLabel: string;
	unsaveAriaLabel: string;
	tooltip: {
		save: string;
		unsave: string;
		saved: string;
		unsaved: string;
	};
	userSignedIn: boolean;

	parentIsHovered: boolean;
	parentIsFocusVisible: boolean;
	onClick?: () => void;
};

// Come from backend
export type SaveConfig = {
	alwaysVisible: boolean; // hardcoded in .tpl file
	pendingDataLinkEvent?: string; //in case the user saved an item when they are logged-out
	saveFetchUrl: string;
	tooltipDisabled?: boolean;
	translationMap: SaveButtonTranslations;
};

export type SaveButtonTranslations = {
	saveAriaLabel?: string;
	unsaveAriaLabel?: string;
	redirectToLoginAndSaveAriaLabel?: string;
	cookieToaster: CookieToasterTranslation;
	tooltip?: TooltipTranslation;
};

export type TooltipTranslation = {
	save?: string;
	unsave?: string;
	saved?: string;
	unsaved?: string;
	redirectToLoginAndSave?: string;
	redirectedToLoginAndSave?: string;
};

export enum SaveButtonVariant {
	DEFAULT = 'Default',
	SAVED_PAGE = 'Saved Page',
}

export enum Brand {
	BLACKROCK = 'blackrock',
	ISHARES = 'ishares',
}

export enum SaveButtonState {
	UNSAVED = 'unsaved',
	SAVE_CLICKED = 'saved-clicked',
	SAVED = 'saved',
	UNSAVE_CLICKED = 'unsave-clicked',
}

export enum SaveDataLinkEvent {
	SAVE = 'save',
	UNSAVE = 'unsave',
	LOGIN_TO_SAVE = 'loginToSave',
	UNDO = 'undo',
}
